import { defineStore } from 'pinia';
import services from '@/services';
import useApi from '@/hooks/useApi';
import utils from '@/utils/index';
import useGeneral from './general';
import router from '@/router';

const { getParam } = utils;
interface InfoState {
  translations: { [key: string]: string } | null;
  images: { [key: string]: string } | null;
  region: string | null;
  lang: string | null;
  googlePlay: string;
  appleStore: string;
  officialWebsite: string;
  navigationBar: {
    menus: {
      name: string;
      link: string;
    }[];
  };
  redirectHint: { domain: string; region: string; lang: string } | null;
  policyLinks: { forParents: string; privacyPolicy: string } | null;
}

const infoState = (): InfoState => ({
  translations: null,
  images: null,
  region: null,
  lang: null,
  googlePlay: '',
  appleStore: '',
  officialWebsite: '',
  navigationBar: {
    menus: [],
  },
  redirectHint: null,
  policyLinks: null,
});

function parseEmptyStrToDefaultKey(obj: { [key: string]: string }) {
  const keys = Object.keys(obj);
  const copyObj = { ...obj };
  const result: { [key: string]: string } = {}
  for (let i = 0; i < keys.length; i++) {
    const current = keys[i];
    if (!copyObj[current]) {
      result[current] = current;
    } else result[current] = copyObj[current]
  }
  return result;
}

const useInfo = defineStore('info', {
  state: infoState,
  actions: {
    async getInfo() {
      const region = getParam('region') || '';
      const lang = getParam('lang') || '';
      const accessToken =
        getParam('access_token') || localStorage.getItem('TOKEN');
      const response = await useApi(() =>
        services.getInfo({ lang, region, ...(accessToken && { accessToken }) }),
      );
      if (!response || response.msg) return;
      const { data, images, translations } = response;
      const translationsWithDefault = parseEmptyStrToDefaultKey(translations);
      this.$patch({ ...data, images, translations: translationsWithDefault });
      const url = `${window.location.origin}${window.location.pathname}?lang=${this.lang}&region=${this.region}`;
      window.history.pushState({}, '', url);
      document.documentElement.setAttribute('lang', String(data.lang));
      localStorage.setItem('REGION', data.region);
      localStorage.setItem('LANG', data.lang);
      if (this.navigationBar.menus.length === 0) {
        const { handleToast } = useGeneral();
        handleToast(true, 'IW_REGION_TOAST');
      }
    },
    getImg(imageKey: string) {
      return this.images !== null ? this.images[imageKey] : '';
    },
    getBgImg(imageKey: string) {
      return this.images !== null ? `background-image: url('${this.images[imageKey]}')` : '';
    },
    getTrans(key: string) {
      return this.translations?.[key] || '';
    },
    checkRoute(route: string, fn: () => void) {
      if (
        this.navigationBar &&
        this.navigationBar.menus.some((item) => item.link === route)
      ) {
        fn();
      } else {
        router.push({
          name: 'NotFound', 
          query: {
            lang: this.lang,
            region: this.region
          },
        });
      }
    },
  },
});

export default useInfo;
